import React from "react";
import style from "./AllOrders.module.css";

export default function AllOrders() {
  return (
    <>
      <h2>AllOrders</h2>
    </>
  );
}
